export enum Role {
    Auditor = 'AUDITOR',
    Manager = 'PPAManager',
    QAAdmin = 'qaAdmin',
    ApplicationAdmin = 'applicationAdmin',
    SystemUser = 'systemUser',
    Admin = 'admin'
}
